/* eslint-disable no-multi-assign */

angular.module('storefrontApp')
    .controller('mainController', [
        '$scope',
        '$location',
        '$window',
        'customerService',
        'storefrontApp.mainContext',
        function (
            $scope,
            $location,
            $window,
            customerService,
            mainContext,
        ) {
            // Base store url populated in layout and can be used for construction url inside controller
            $scope.baseUrl = {};

            $scope.$watch(function () {
                $scope.currentPath = $location.$$path.replace('/', ''); // eslint-disable-line angular/no-private-call
            });

            $scope.$on('storefrontError', function (event, data) {
                $scope.storefrontNotification = data;
                $scope.storefrontNotification.detailsVisible = false;
            });

            $scope.toggleNotificationDetails = function () {
                $scope.storefrontNotification.detailsVisible = !$scope.storefrontNotification.detailsVisible;
            };

            $scope.closeNotification = function () {
                $scope.storefrontNotification = null;
            };

            // For outside app redirect (To reload the page after changing the URL, use the lower-level API)
            $scope.outerRedirect = function (absUrl) {
                $window.location.href = absUrl;
            };

            // change in the current URL or change the current URL in the browser (for app route)
            $scope.innerRedirect = function (path) {
                $location.path(path);
                $scope.currentPath = $location.$$path.replace('/', ''); // eslint-disable-line angular/no-private-call
            };

            $scope.stringifyAddress = function (address) {
                let stringifiedAddress = address.firstName + ' ' + address.lastName + ', ';
                stringifiedAddress += address.organization ? address.organization + ', ' : '';
                stringifiedAddress += address.countryName + ', ';
                stringifiedAddress += address.regionName ? address.regionName + ', ' : '';
                stringifiedAddress += address.city + ' ';
                stringifiedAddress += address.line1 + ', ';
                stringifiedAddress += address.line2 ? address.line2 : '';
                stringifiedAddress += address.postalCode;

                return stringifiedAddress;
            };

            $scope.getObjectSize = function (obj) {
                let size = 0,
                    key;

                for (key in obj) { // eslint-disable-line no-restricted-syntax
                    if (obj.hasOwnProperty(key)) { // eslint-disable-line no-prototype-builtins
                        size += 1;
                    }
                }

                return size;
            };

            mainContext.getCustomer = $scope.getCustomer = function () {
                customerService.getCurrentCustomer()
                    .then(function ({ data: customer }) {
                        if (customer.isRegisteredUser && $window.appInsights) {
                            // eslint-disable-next-line max-len
                            // https://docs.microsoft.com/en-us/azure/azure-monitor/app/api-custom-events-metrics#authenticated-users
                            $window.appInsights.setAuthenticatedUserContext(
                                customer.userName
                                    .replace('\\', '\\\\')
                                    .replace(/[,;=|\s]+/g, '_'),
                            );
                        }

                        if (!customer.addresses) {
                            customer.addresses = [];
                        }

                        let addressId = 1;

                        _.each(customer.addresses, function (address) {
                            address.id = addressId;
                            addressId += 1;
                        });

                        customer.isContact = customer.memberType === 'Contact';
                        mainContext.customer = $scope.customer = customer;
                    });
            };

            $scope.getCustomer();

            // Remove "rs-loading" class from Body tag
            // eslint-disable-next-line angular/document-service
            document.body.className = document.body.className.replace(/\brs-loading\b/g, '');
        },
    ])

    .factory('storefrontApp.mainContext', function () {
        return {};
    });
